(function () {
	const DEBUG = true; // Turn off after tests
	const EXTRA_OFFSET = 50; // Extra offset height from the header

	function log(...args) { if (DEBUG) console.log('[reviews-scroll]', ...args); }
	function warn(...args) { if (DEBUG) console.warn('[reviews-scroll]', ...args); }

	// Now always return .product-reviews-header
	function findReviewsPanel() {
		return document.querySelector('.product-reviews-header');
	}

	function findTabForPanel(panel) {
		if (!panel || !panel.id) return null;
		let btn = document.querySelector(`[aria-controls="${panel.id}"]`);
		if (btn) return btn;
		const candidates = Array.from(document.querySelectorAll('button, [role="tab"], .oke-w-navBar-item'));
		return candidates.find(b => (b.textContent || '').trim().toLowerCase().includes('reviews')) || null;
	}

	function getHeaderOffset() {
		const headerSelectors = ['header.site-header','header','.site-header','.header','.header-wrapper'];
		for (const sel of headerSelectors) {
			const el = document.querySelector(sel);
			if (el) {
				const st = getComputedStyle(el);
				if (st.position === 'fixed' || st.position === 'sticky') {
					return el.getBoundingClientRect().height || 0;
				}
			}
		}
		return 0;
	}

	function waitFor(conditionFn, timeout = 3000, interval = 100) {
		return new Promise(resolve => {
			const start = Date.now();
			(function poll() {
				try { if(conditionFn()) return resolve(true); } catch(e) {}
				if(Date.now() - start > timeout) return resolve(false);
				setTimeout(poll, interval);
			})();
		});
	}

	function waitForSelector(selector, timeout = 5000) {
		return new Promise(resolve => {
			const el = document.querySelector(selector);
			if(el) return resolve(el);
			const observer = new MutationObserver(() => {
				const found = document.querySelector(selector);
				if(found) { observer.disconnect(); resolve(found); }
			});
			observer.observe(document.documentElement, {childList: true, subtree: true});
			setTimeout(() => { observer.disconnect(); resolve(null); }, timeout);
		});
	}

	function getElementY(el) {
		const rect = el.getBoundingClientRect();
		return window.scrollY + rect.top;
	}

	async function openPanelAndScroll(panel) {
		if (!panel) { warn('panel missing'); return; }

		log('panel found', panel);
		const tabBtn = findTabForPanel(panel);
		if(tabBtn){
			try { log('clicking tab button', tabBtn); tabBtn.click(); }
			catch(e){ warn('tabBtn.click() failed', e); }
		}

		const becameVisible = await waitFor(() => {
			const rect = panel.getBoundingClientRect();
			return rect.height > 0 && rect.bottom > 0;
		}, 3000, 80);

		if(!becameVisible){ warn('panel not visible'); return; }

		await new Promise(r => setTimeout(r, 150)); // layout stabilization

		const headerOffset = getHeaderOffset();
		const targetY = Math.max(0, getElementY(panel) - headerOffset - EXTRA_OFFSET);

		log('scroll targetY:', targetY);

		const html = document.documentElement;
		const prevScrollBehavior = html.style.scrollBehavior;
		html.style.scrollBehavior = 'auto';

		await smoothScroll(window, targetY, 400);
		html.style.scrollBehavior = prevScrollBehavior;

		requestAnimationFrame(() => {
			try {
				panel.setAttribute('tabindex', '-1');
				const rectNow = panel.getBoundingClientRect();
				if(rectNow.top >= 0 && rectNow.bottom <= window.innerHeight){
					panel.focus({ preventScroll: true });
				}
			} catch(e) {}
		});

		log('scroll action executed');
	}

	function smoothScroll(container, targetY, duration = 400){
		return new Promise(resolve => {
			const startY = container === window ? window.scrollY : container.scrollTop;
			const distance = targetY - startY;
			let startTime;

			function step(timestamp){
				if(!startTime) startTime = timestamp;
				const progress = Math.min((timestamp - startTime) / duration, 1);
				const ease = 0.5 - Math.cos(progress * Math.PI) / 2;

				if(container === window) window.scrollTo(0, startY + distance * ease);
				else container.scrollTop = startY + distance * ease;

				if(progress < 1) requestAnimationFrame(step);
				else resolve();
			}

			requestAnimationFrame(step);
		});
	}

	function onDocumentClick(e){
		const rating = e.target.closest && e.target.closest('.product_rating');
		if(!rating) return;
		e.preventDefault();

		let panel = findReviewsPanel();
		if(panel){ openPanelAndScroll(panel); return; }

		(async () => {
			panel = await waitForSelector('.product-reviews-header', 5000);
			if(!panel){ warn('reviews panel did not appear'); return; }
			openPanelAndScroll(panel);
		})();
	}

	if(!window.__reviews_scroll_listener_attached){
		document.addEventListener('click', onDocumentClick, {passive:false});
		window.__reviews_scroll_listener_attached = true;
		log('listener attached');
	}

	(function markClickable(){
		const rating = document.querySelector('.product_rating');
		if(rating) rating.style.cursor = 'pointer';
		const panel = findReviewsPanel();
		if(panel) log('panel initially present', panel);
	})();

})();